<template>
    <div>
        <div class="form-check form-switch">
            <input class="form-check-input" v-model="reuse" type="checkbox" @change="changeReuse()" role="switch" id="flexSwitchCheckDefault">
            <label class="form-check-label" for="flexSwitchCheckDefault" >Reutilizar datos</label>
        </div>
        <select v-if="reuse" name="" id="" class="form-control my-1" @change="getClasses($event)">
            <option value="" disabled selected>Seleccione un curso</option>
            <option v-for="course in coursesList" :value="course.id">{{ course.nombre }}</option>
        </select>
        <select v-if="reuse" name="" id="" class="form-control my-1" @change="copyData($event)">
            <option value="" disabled selected>Seleccione una clase</option>
            <option v-for="clas in classesList" :value="clas.id">{{ clas.name }}</option>
        </select>
        <p v-if="reuse" style="word-break: normal;" class="text-success mb-0">- Solo se mostrarán las clases que tienen videos</p>
        <p v-if="reuse" style="word-break: normal;" class="text-success mt-0">- La opción de video introductorio no se marca automáticamente</p>
        <form @submit.prevent="storeClass">
            <div
                class="row"
                v-loading="loading"
                element-loading-text="Cargando..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.6)"
            >
                <div class="col-lg-12 mb-2">
                    <label>Titulo</label>
                    <el-input
                        v-model="form.name"
                        placeholder="Título de la clase"
                        type="text"
                    ></el-input>
                </div>
                <div class="mb-5 col-12 pb-5 pt-3">
                    <label>Descripción</label>
                    <QuillEditor
                        ref="quill_description"
                        v-model:content="form.description"
                        contentType="html"
                        theme="snow"
                        toolbar="full"
                        :modules="modules"
                    />
                </div>
                <div class="mb-5 col-12 pb-5 pt-3">
                    <label>Enlaces externos</label>
                    <QuillEditor
                        ref="quill_links"
                        v-model:content="form.external_links"
                        contentType="html"
                        theme="snow"
                        toolbar="full"
                        :modules="modules"
                    />
                </div>

                <div class="col-lg-12 my-4">
                    <el-checkbox
                        v-model="is_preview"
                        label="¿Es video introductorio?"
                        size="large"
                    />
                </div>

                <div class="col-lg-6 col-md-12 text-center">
                    <div v-if="!reuse">
                        <label>Clase Video</label>
                        <el-upload
                            class="upload-demo"
                            ref="uploadClassVideo"
                            action=""
                            :on-change="onUploadVideoChange"
                            :http-request="storeClass"
                            multiple
                            drag
                            :limit="1"
                            :auto-upload="false"
                            :file-list="fileVideoList"
                            :on-exceed="handleExceedVideo"
                            :on-remove="handleRemoveVideo"
                            accept=".mp4"
                        >
                            <em class="el-icon-upload"></em>
                            <div class="el-upload__text">
                                Suelta tu archivo aquí o
                                <em>haz clic para cargar</em>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                Solo archivos mp4
                            </div>
                        </el-upload>
                    </div>
                    <div v-else>
                        <p><strong>Clase video</strong></p>
                        <video :src="classSelected.url" width="320" controls>
                            Tu navegador no admite el elemento <code>video</code>
                        </video>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 text-center">
                    <div v-if="!reuse">
                        <label>Recursos</label>
                        <el-upload
                            class="upload-demo"
                            drag
                            ref="uploadResources"
                            action=""
                            :on-change="onUploadResourceChange"
                            :http-request="storeClass"
                            multiple
                            :auto-upload="false"
                            :file-list="fileResourcesList"
                            :on-remove="handleRemoveResource"
                        >
                            <em class="el-icon-upload"></em>
                            <div class="el-upload__text">
                                Suelta tu archivo aquí o
                                <em>haz clic para cargar</em>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                Máximos 3mb - La carga de recursos es opcional
                            </div>
                        </el-upload>
                    </div>
                    <div v-else>
                        <p><strong>Recursos</strong></p>
                        <div class="table-responsive">
                            <table class="table">
                                <tbody>
                                    <tr v-for="resource in resources" :key="resource.id">
                                        <td scope="row">{{ resource.filename }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="row">
                    <div class="col-lg-12 text-center mt-2">
                        <el-button data-bs-dismiss="modal">Cancelar</el-button>
                        <el-button
                            type="primary"
                            native-type="submit"
                            :disabled="isSubmitting"
                            >Guardar</el-button
                        >
                    </div>
                </div>
            </span>
        </form>
    </div>
</template>
<script>
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import BlotFormatter from "quill-blot-formatter";
import { Plus } from "@element-plus/icons-vue";

export default {
    props: {
        moduleId: {
            type: undefined,
            required: true,
        },
    },
    data() {
        return {
            modules: {
                name: "blotFormatter",
                module: BlotFormatter,
                options: {
                    /* options */
                },
            },
            loading: false,
            form: {
                description: "",
            },
            fileVideoList: [],
            fileResourcesList: [],
            isSubmitting: false,
            is_preview: false,
            link: "",
            links: [],
            coursesList: [],
            classesList: [],
            reuse: false,
            classSelected: [],
            resources: [],
        };
    },
    components: {
        QuillEditor,
        Plus,
    },
    methods: {
        changeReuse(){
            this.reuse == this.reuse ? false : true;
            if(this.reuse){
                this.getCourses();
            }
            this.inputReuse = true;
        },
        async copyData(event) {
            try {
                const response = await axios.get(`/productos/module/class/${event.target.value}/info`);
                
                const data = response.data;

                this.classSelected = data.class;
                this.resources = data.resources;
                this.form.name = this.classSelected.name;

                await this.$refs.quill_description.setHTML(this.classSelected.description);
                this.form.description = this.classSelected.description;

                await this.$refs.quill_links.setHTML(this.classSelected.external_links);
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        },
        async getCourses(){
            await axios.get("/productos/all-courses").then((r) => {
                this.coursesList = r.data;
            });
        },
        async getClasses(event){
            await axios.get(`/productos/${event.target.value}/all-classes-with-video`).then((r) => {
                this.classesList = r.data;
            });
        },
        saveLink() {
            this.links.push(this.link);
        },
        hasEspecialCharacters(text) {
            const regex = new RegExp(
                /^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g
            );
            return regex.test(text);
        },
        validateFields() {
            if (
                !this.form.name ||
                this.form.name.trim() === "" ||
                this.form.name.length === 0
            ) {
                this.$message.warning("Titulo esta vacio!");
                return false;
            }
            if (this.form.name.length >= 255) {
                this.$message.warning("Titulo demasiado largo!");
                return false;
            }
            if (
                !this.form.description ||
                this.form.description.trim() === "" ||
                this.form.description.length === 0
            ) {
                this.$message.warning("Descripcion esta vacio!");
                return false;
            }

            // if (!this.$refs.uploadClassVideo) {
            //   this.$message.warning('¡El video de la clase esta vacio!');
            //   return false;
            // }
            return true;
        },

        handleExceedVideo(video) {
            this.$message.warning(
                `El límite es 1, haz seleccionado ${video.length} videos`
            );
        },
        handleRemoveVideo(fileremoved, fileVideo) {
            this.fileVideoList = fileVideo;
        },
        onUploadVideoChange(video) {
            this.fileVideoList = [];
            const isVideo = video.raw.type === "video/mp4";
            // 40mb
            const fortymb = 419430400000;
            const isLt3MB = video.size < fortymb;

            if (!isVideo) {
                this.$message.error(
                    "Solo puede cargar archivos en formato .mp4"
                );
                this.$refs.uploadClassVideo.clearFiles();
                return false;
            }

            if (!isLt3MB) {
                this.$message.error("El archivo no debe pesar más de 40 mb!");
                this.$refs.uploadClassVideo.clearFiles();
                return false;
            }
            this.fileVideoList.push(video);
        },

        onUploadResourceChange(documents) {
            // const isLt10MB = documents.size < 10000000;
            // if (!isLt10MB) {
            //     this.$message.error("El archivo no debe pesar más de 3mb!");
            //     this.$refs.uploadResources.clearFiles();
            //     return false;
            // }
            this.fileResourcesList.push(documents);
        },

        handleRemoveResource(fileremoved, fileList) {
            this.fileResourcesList = fileList;
        },
        resetAll() {
            this.isSubmitting = false;
            this.form = {};
            this.fileVideoList = [];
            this.fileResourcesList = [];
            this.isSubmitting = false;
            this.is_preview = false;
            this.coursesList = [];
            this.classesList = [];
            this.reuse = false;
            this.classSelected = [];
            this.resources = [];
            this.$refs.quill_description.setHTML("");
            this.$refs.quill_links.setHTML("");
        },

        async storeClass() {
            var reuse = this.reuse ? 1 : 0;
            if (this.validateFields()) {
                const formdata = new FormData();
                formdata.append("title", this.form.name);
                formdata.append("description", this.form.description);
                formdata.append("module_id", this.moduleId);
                formdata.append("is_preview", Number(this.is_preview));
                formdata.append("external_links", this.form.external_links);
                formdata.append("isReusable", reuse);
                if(this.reuse){
                    formdata.append("video_id", this.classSelected.video_id);
                    formdata.append("resources", JSON.stringify(this.resources));
                }else{
                    if (this.fileVideoList[0] != null) {
                        const resultTime = await this.getDuration(
                            this.fileVideoList[0].raw
                        );
                        formdata.append("video", this.fileVideoList[0].raw);
                        formdata.append("time", resultTime);
                    }
                    for (let i = 0; i < this.fileResourcesList.length; i++) {
                        let file = this.fileResourcesList[i].raw;
                        formdata.append("resources[]", file);
                    }
                }

                try {
                    this.loading = true;
                    this.isSubmitting = true;
                    const config = {
                        headers: { "content-type": "multipart/form-data" },
                    };
                    const { data } = await axios.post(
                        `/productos/module/class/${this.moduleId}/save`,
                        formdata,
                        config
                    );
                    const { status, classes } = await data;
                    const response =
                        (await status) == "ok"
                            ? this.$message.success(
                                  "La clase ha sido registrado correctamente"
                              )
                            : await this.$message.warning(
                                  "Error al validar datos"
                              );
                    this.resetAll();
                    this.loading = false;
                    $("#create-class-modal").modal("hide");
                    // Call function from child
                    this.$parent.$parent.refreshClassData();
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    console.log(error);
                }
            }
        },
        getDuration(fileVideo) {
            window.URL = window.URL || window.webkitURL;
            return new Promise((resolve) => {
                let video = document.createElement("video");
                video.preload = "metadata";

                video.onloadedmetadata = function () {
                    window.URL.revokeObjectURL(video.src); //eliminar anterior objeto
                    const seconds = video.duration;
                    const result = new Date(seconds * 1000)
                        .toISOString()
                        .slice(11, 19);
                    resolve(result);
                };
                video.src = URL.createObjectURL(fileVideo);
            });
        },
    },
};
</script>
